import Swiper from 'swiper';
import { Pagination, Grid, Navigation, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import 'swiper/css/navigation';
import 'swiper/css/a11y';

window.Swiper = Swiper;
window.SwiperModules = { Pagination, Grid, Navigation, A11y };
